import { useContext, useEffect, useState } from "react";
import { FAQ } from "../types";
import { fetchFAQ } from '../api';
import cardStyles from "../styles/Card.module.css";
import { useAuth } from "react-oidc-context";
import { GlobalContext } from "../App";

function Item(item:FAQ) {
    const [isExpanded, setIsExpanded] = useState(false)

    function changeIsExpanded() {
        setIsExpanded(!isExpanded)
    }

    return (
        <div
            onClick={changeIsExpanded}
            className={cardStyles.card}
        >
            <b>Question: {item.question} </b>[Click to expand]
            {isExpanded ? <p>{item.answer}</p> : null}
        </div>
    )

}

function displayFaq(faqs:FAQ[]) {
{
        console.log(faqs)
        return (
            <div>
                {faqs.map(faq => (
                    <Item {...faq} key={faq.id} />
                ))}
            </div>
        );
    }
}

export default function FAQs() {
    const auth = useAuth();
    const [faqs, setFaqs] = useState<FAQ[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const {globalSite} = useContext(GlobalContext);

    useEffect(() => {
        if (isLoading && faqs !== undefined && faqs.length === 0) {
            fetchFAQ(globalSite)
            .then((data) => {
                setFaqs(data);
                setIsLoading(false)
            })
        }
    }, [faqs, setFaqs])

    if (isLoading) {
        return <div>Loading ...</div>
    }

    return (
        <div>
            {displayFaq(faqs)}
        </div>
    )
}
